import React, { useEffect, useMemo, useState } from "react";
import SideBar from "../components/SideBar";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { API_URL } from "../constant";

function ManagePromotion() {

    const navigate = useNavigate();
    const [search, setSearch] = useState("");
    const [currentPage, setCurrentPage] = useState(1);
    const [promotions, setPromotions] = useState([]);
    const [suppliers, setSuppliers] = useState([]);
    const [status, setStatus] = useState("all");
    const [supplier, setSupplier] = useState("all");
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState("");
    const itemsPerPage = 6;

    // Create axios instance with auth headers
    const api = axios.create({
      baseURL: API_URL ,
    });

    // Add token to requests
    api.interceptors.request.use((config) => {
      const token = localStorage.getItem("auth_token");
      if (token) {
        config.headers.Authorization = `Bearer ${token}`;
        config.headers.Accept = "application/json";
      }
      return config;
    });

    const statuses = [
      { id: "all", name: "All" },
      { id: "new", name: "New" },
      { id: "used", name: "Used" },
      { id: "cancelled", name: "Cancelled" },
    ];

    const supplierOptions = useMemo(() => {
      const opts = [];
      suppliers.forEach((s) => {
        const id = s.id ?? s.supplier_id ?? s.retail_business_id ?? s.agent_id ?? s.value;
        const name =
          s.retail_name ||
          s.store_name ||
          s.retailer_name ||
          s.business_name ||
          s.company_name ||
          s.name ||
          s.supplier_name ||
          s.supplierName ||
          s.display_name;
        if (id && name) opts.push({ id: String(id), name });
      });

      if (opts.length === 0) {
        promotions.forEach((p) => {
          const pid = p.supplier_id || p.Supplier_id || p.SupplierId || p.supplierId || p?.supplier?.id;
          const pname = p?.supplier?.retail_name || p?.supplier?.name || p?.Supplier;
          if (pid && pname) opts.push({ id: String(pid), name: pname });
        });
      }

      const unique = new Map();
      opts.forEach((o) => {
        if (!unique.has(o.id)) unique.set(o.id, o.name);
      });

      return [{ id: "all", name: "All Suppliers" }, ...Array.from(unique.entries()).map(([id, name]) => ({ id, name }))];
    }, [promotions, suppliers]);

    const supplierLookup = useMemo(() => {
      const byId = new Map();
      const byCode = new Map();
      suppliers.forEach((s) => {
        const id = s.id ?? s.supplier_id ?? s.retail_business_id ?? s.agent_id ?? s.value;
        const code = s.code ?? s.supplier_code ?? s.supplierCode;
        const label =
          s.store_name ||
          s.retailer_name ||
          s.business_name ||
          s.company_name ||
          s.name ||
          s.supplier_name ||
          s.supplierName ||
          s.display_name;
        if (label) {
          if (id) byId.set(String(id), label);
          if (code) byCode.set(String(code), label);
        }
      });
      return { byId, byCode };
    }, [suppliers]);

      const goToCreatePromotion = () => {
        navigate("/create-promotion");
      };

      useEffect(() => {
        const fetchPromotions = async () => {
          setLoading(true);
          setError("");
          try {
            const res = await api.get("/superadmin/promos");
            const data = res.data?.data;
            const list = data?.data ?? data ?? [];
            setPromotions(Array.isArray(list) ? list : []);
          } catch (err) {
            const msg = err?.response?.data?.message || err?.message || "Failed to load promotions";
            setError(msg);
            console.error("Failed to load promotions", err);
          } finally {
            setLoading(false);
          }
        };
        fetchPromotions();
        const fetchSuppliers = async () => {
          try {
            const res = await api.get("/superadmin/suppliers");
            const data = res?.data?.data ?? res?.data ?? [];
            const list = Array.isArray(data?.data) ? data.data : Array.isArray(data) ? data : [];
            setSuppliers(list);
          } catch (err) {
            console.error("Failed to load suppliers for filter", err);
          }
        };
        fetchSuppliers();
      }, []);

      
    
      useEffect(() => {
        setCurrentPage(1);
      }, [search, status, supplier]);
    
      const getSupplierId = (promotion) =>
        promotion.supplier_id ||
        promotion.Supplier_id ||
        promotion.SupplierId ||
        promotion.supplierId ||
        promotion?.supplier?.id;

      const getSupplierName = (promotion) => {
        const id = getSupplierId(promotion);
        const fromLookup = id ? supplierLookup.byId.get(String(id)) : undefined;
        return (
          fromLookup ||
          promotion?.supplier?.retail_name ||
          promotion?.supplier?.name ||
          promotion?.Supplier ||
          ""
        );
      };

      const filteredPromotions = promotions.filter((promotion) => {
        const uniqueId = (promotion.unique_code || promotion.UniqueID || "").toString().toLowerCase();
        const supplierId = getSupplierId(promotion);
        const supplierName = getSupplierName(promotion).toLowerCase();
        const productName = (promotion?.product?.name || promotion.Product || "").toLowerCase();

        const searchLower = search.toLowerCase();
        const searchMatch =
          uniqueId.includes(searchLower) ||
          supplierName.includes(searchLower) ||
          productName.includes(searchLower);

        const statusLower = (promotion.status || promotion.Status || "").toLowerCase();
        const statusMatch = status === "all" || statusLower === status.toLowerCase();

        const supplierMatch =
          supplier === "all" ||
          String(supplierId || "").toLowerCase() === String(supplier).toLowerCase();

        return searchMatch && statusMatch && supplierMatch;
      });
    
      const totalPages = Math.ceil(filteredPromotions.length / itemsPerPage);
      const startIndex = (currentPage - 1) * itemsPerPage;
      const paginatedPromotions = filteredPromotions.slice(
        startIndex,
        startIndex + itemsPerPage,
      );
    
      const handleRowClick = (promotion) => {
        navigate("/promotion-details", { state: { promotion } });
      };

  return (
    <div className="manage-member-layout">
          <SideBar />
          <div className="main-content">
            <div className="header-bar" style={{ border: 0, boxShadow: "none" }}>
              <div className="header-top">
                <h2 className="header-title">Manage Promotion</h2>
                <button className="action-btn" onClick={goToCreatePromotion}>
                  + Add New Promotion
                </button>
              </div>
    
              <div className="filters">
                <div className="input-group">
                  <label>Filter by supplier:</label>
                  <select
                    value={supplier}
                    onChange={(e) => setSupplier(e.target.value)}
                    className="filter-select"
                  >
                    {supplierOptions.map((sup) => (
                      <option key={sup.id} value={sup.id}>
                        {sup.name}
                      </option>
                    ))}
                  </select>
                </div>
    
                <div className="input-group">
                  <label>Filter by status:</label>
                  <select
                    value={status}
                    onChange={(e) => setStatus(e.target.value)}
                    className="filter-select"
                  >
                    {statuses.map((status) => (
                      <option key={status.id} value={status.id}>
                        {status.name}
                      </option>
                    ))}
                  </select>
                </div>
    
                <div className="input-group">
                  <label>Search:</label>
                  <input
                    type="text"
                    placeholder="Search by product or supplier"
                    value={search}
                    onChange={(e) => setSearch(e.target.value)}
                    className="search-input"
                   maxLength={20} />
                </div>
              </div>
    
              <div className="table-container">
                    {error && (
                      <div style={{ color: "red", marginBottom: "8px" }}>{error}</div>
                    )}
                <table className="member-table">
                  <thead>
                    <tr>
                      <th>UniqueID</th>
                      <th>Product</th>
                      <th>Supplier</th>
                      <th>TopCoin</th>
                      {/* <th>Sub Category</th> */}
                      <th>Status</th>
                    </tr>
                  </thead>
                  <tbody>
                    {loading ? (
                      <tr>
                        <td colSpan="6" style={{ textAlign: "center" }}>
                          Loading...
                        </td>
                      </tr>
                    ) : paginatedPromotions.length > 0 ? (
                      paginatedPromotions.map((promotion, i) => {
                        const uniqueId = promotion.unique_code || promotion.UniqueID;
                        const productName = promotion?.product?.name || promotion.Product;
                        const supplierName = getSupplierName(promotion);
                        const statusVal = promotion.status || promotion.Status;
                        const topCoin = promotion.topcoin_amount || promotion.TopCoin;
                        return (
                        <tr 
                          key={uniqueId || i} 
                          onClick={() => handleRowClick(promotion)}
                          style={{ cursor: "pointer" }}
                        >
                          <td>{uniqueId}</td>
                          <td>{productName || "N/A"}</td>
                          <td>{supplierName || "N/A"}</td>
                          <td>{topCoin || "N/A"}</td>
                          <td>
                            <span className={`status ${statusVal?.toLowerCase()}`}>
                              {statusVal || "N/A"}
                            </span>
                          </td>
                        </tr>
                        );
                      })
                    ) : (
                      <tr>
                        <td colSpan="6" style={{ textAlign: "center" }}>
                          No promotions found
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
    
                {/* Pagination */}
                {!loading && filteredPromotions.length > 0 && (
                  <div className="pagination">
                    <button
                      className="page-btn"
                      onClick={() => setCurrentPage((p) => Math.max(p - 1, 1))}
                      disabled={currentPage === 1}
                    >
                      &lt;
                    </button>
                    {Array.from({ length: totalPages }, (_, i) => (
                      <button
                        key={i}
                        className={`page-btn ${currentPage === i + 1 ? "active" : ""}`}
                        onClick={() => setCurrentPage(i + 1)}
                      >
                        {i + 1}
                      </button>
                    ))}
                    <button
                      className="page-btn"
                      onClick={() =>
                        setCurrentPage((p) => Math.min(p + 1, totalPages))
                      }
                    //   disabled={currentPage === totalPages}
                    >
                      &gt;
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
  )
}

export default ManagePromotion